import { inject, NgModule } from '@angular/core';
import { EventService } from 'shared/services/event.service';
import { Router } from '@angular/router';
import { UserStore } from 'features/user/store/user.store';
import { UserAuthEvent } from 'features/user/store/auth.store';

@NgModule({})
export class ProfileEventModule {
  eventService = inject(EventService);
  route = inject(Router);
  store = inject(UserStore)
  constructor() {
    this.eventService.on(UserAuthEvent.LOGIN, () => {
      this.store.loadUserInfo();
      this.store.loadRoleGroups();
    });
    this.eventService.on(UserAuthEvent.LOGOUT, () => {
      this.store.reset()
      this.route.navigate(['/login']);
    });
  }
}
